/*
 * WELLF: social proof taste reel  (section: wellf-social-proof)
 * ---------------------------------------------------------------------------
 * Tap the print stack to play, WITH SOUND. Two rules drive every decision here:
 *
 * 1. NOTHING DOWNLOADS UNTIL A TAP. The <video> is created on first interaction and
 *    no src exists in the DOM before that, which is stronger than preload="none".
 *    The section sits below the fold on both templates, so it must cost nothing to
 *    scroll past.
 *
 * 2. SOUND NEEDS THE GESTURE. play() is called synchronously inside the click
 *    handler. Await anything first, or scroll first, and the browser treats it as
 *    programmatic and forces muted. The audio IS the content on a reactions reel,
 *    so this ordering is not negotiable.
 *
 * Source order is m3u8 then mp4, set in the Liquid. Safari and iOS play the HLS
 * natively and adapt bitrate to bandwidth; Chromium ignores it and takes the mp4.
 *
 * The buy-box teaser only SCROLLS. It deliberately does not start playback: that
 * would be a second gesture-free play, and landing on an already-playing video with
 * sound is hostile. The visitor taps the reel when they arrive.
 */
(function () {
  'use strict';

  var reel = document.querySelector('[data-wellf-reel]');
  if (!reel) return;

  var video = null;
  var bar = reel.querySelector('[data-reel-bar] i');

  function prefersReducedMotion() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }

  function buildVideo() {
    if (video) return video;
    var hls = reel.getAttribute('data-src-hls');
    var mp4 = reel.getAttribute('data-src-mp4');
    if (!hls && !mp4) return null;

    video = document.createElement('video');
    video.setAttribute('playsinline', '');           // without this iOS goes fullscreen
    video.playsInline = true;
    video.preload = 'auto';                          // only reached after a tap
    video.loop = false;
    video.controls = false;
    // The engagement instrument in wellf-events.js only binds to a video carrying this
    // attribute, and only counts a play that follows a gesture on the element itself.
    // The Liquid sets data-wellf-measure on the product template only, so the same
    // section on the homepage plays normally and is deliberately not measured. Without
    // this the attribute would be unconditional, and the reel events would start
    // reporting homepage plays the moment wellf-events.js is ever loaded site-wide.
    if (reel.hasAttribute('data-wellf-measure')) {
      video.setAttribute('data-wellf-video-engagement', '');
    }

    if (hls) { var s1 = document.createElement('source'); s1.src = hls; s1.type = 'application/x-mpegURL'; video.appendChild(s1); }
    if (mp4) { var s2 = document.createElement('source'); s2.src = mp4; s2.type = 'video/mp4'; video.appendChild(s2); }

    video.addEventListener('timeupdate', function () {
      try {
        if (!bar || !video.duration) return;
        bar.style.width = Math.min(100, (video.currentTime / video.duration) * 100) + '%';
      } catch (e) {}
    }, { passive: true });

    video.addEventListener('ended', function () {
      reel.classList.remove('is-playing');
      try { video.currentTime = 0; } catch (e) {}
      if (bar) bar.style.width = '0%';
    }, { passive: true });

    reel.insertBefore(video, reel.firstChild);
    return video;
  }

  reel.addEventListener('click', function () {
    var v = buildVideo();
    if (!v) return;

    if (!v.paused) { v.pause(); reel.classList.remove('is-playing'); return; }

    // Sound on. This is a tap, so the browser allows it. Do NOT await anything above.
    v.muted = false;
    v.volume = 1;
    reel.classList.add('is-playing');

    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        // Some in-app webviews still refuse audio. Falling back to muted playback is
        // better than a dead button; the sound pill stays visible so it can be tapped.
        try {
          v.muted = true;
          reel.classList.remove('is-playing');
          reel.classList.add('is-playing', 'is-muted');
          v.play().catch(function () { reel.classList.remove('is-playing', 'is-muted'); });
        } catch (e) { reel.classList.remove('is-playing'); }
      });
    }
  }, { passive: true });

  // Pause when scrolled away. Essential once there is audio: nobody wants a voice
  // continuing from off screen.
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      if (!e.isIntersecting && video && !video.paused) {
        video.pause();
        reel.classList.remove('is-playing');
      }
    }, { threshold: 0.25 }).observe(reel);
  }

  // ── buy-box teaser: scroll only ──
  var teaser = document.querySelector('[data-wellf-reel-teaser]');
  if (teaser) {
    teaser.addEventListener('click', function () {
      try {
        reel.scrollIntoView({
          block: 'center',
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      } catch (e) {
        try { reel.scrollIntoView(); } catch (err) {}
      }
    }, { passive: true });
  }
})();
